import { IndonesianCities } from "data/cities";
import Head from "next/head";
import Script from "next/script";
import React from "react";

/* eslint-disable */
const RegisterTrial: React.FC = () => {
  return (
    <>
      <Head>
        <>
          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/owl.carousel@2.3.4/dist/assets/owl.carousel.min.css"
          />

          <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
          <script src="https://cdn.jsdelivr.net/npm/jquery-validation@1.19.3/dist/jquery.validate.js"></script>
          <script src="https://cdn.jsdelivr.net/npm/owl.carousel@2.3.4/dist/owl.carousel.min.js"></script>
          <style type="text/css">
            {`
    .parentForm {
        width: 100%;
        min-height: calc(100vh - 0px);
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .parentForm .container {
        display: flex;
        position: relative;
        flex-direction: row;
        width: 831px;
        height: 540px;
        background: #ffffff;
        border-radius: 12px;
        font-family: Poppins;
    }

    .parentForm .container .loadingDiv {
        position: absolute;
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 30px;
    }

    .parentForm .leftSection {
        width: 254px;

        box-sizing: content-box;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        background: #1e5af6;
    }

    .parentForm .carousel-desktop {
        display: block;
        height: 100%;
    }
    .parentForm .owl-carousel-image {
      height: 540px;
      object-fit: cover;
    }

    .parentForm .carousel-mobile {
        display: none;
    }

    .parentForm .leftSection .owl-dots {
        bottom: -4px;
        left: 75px;
        position: absolute;
    }

    .parentForm .h2 {
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 30px;
        color: #1E5AF6;
        margin: 7px 0 21px 0;
    }

    .parentForm .h3 {
        display: none;
    }

    .parentForm .formContainer {
        padding: 19px 34px;
        width: 509px;
        display: flex;
        flex-direction: column;
        box-sizing: initial;
    }

    .parentForm form {
        margin-bottom: 0;
    }

    .parentForm .formRow {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .parentForm .formRowLast {
        justify-content: end;
    }

    .parentForm .formGroup {
        display: flex;
        flex-direction: column;
        width: 247px;
        min-height: 85px;
    }

    .parentForm .formGroupClass {

        margin-right: 10px;
    }

    .parentForm .formGroupEmail {
        width: 100%;
    }

    .parentForm .inputContainer {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .parentForm .minHeight {
        min-height: 55px;
    }

    .parentForm .checkboxContainer {
        display: flex;
        align-items: center;
        margin-left: 79px;
    }

    .parentForm .checkboxContainer label {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 13px;
    }

    .parentForm .inputGroup {
        display: flex;
        width: 100%;
    }

    .parentForm .formGroup .label {
        color: #1e5af6;
        font-weight: bold;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 5px;
    }

    .parentForm .serverError {
        font-family: Overpass;
        font-size: 11px;
        line-height: 15px;
        color: #EC3360;
        margin-top: 4px;
        min-height: 25px;
    }

    .parentForm .formGroup label.error {
        font-family: Overpass;
        font-size: 10px;
        line-height: 15px;
        color: #EC3360;
    }

    .parentForm .formGroup input[type=text] {
        padding: 10px 16px;
        border: 2px solid #D1DAE6;
        box-sizing: border-box;
        border-radius: 6px;
        width: 100%;
        font-size: 13px;
        font-family: Overpass;
    }

    .parentForm .formGroup input[type=text].error {
        border: 2px solid #EC3360;
    }

    .parentForm select:focus,
    .parentForm input:focus {
        outline: none;
    }

    .parentForm .formGroup select {
        padding: 9px 11px;
        border: 2px solid #D1DAE6;
        box-sizing: border-box;
        border-radius: 6px;
        margin-right: 6px;
        background: #ffffff;
        font-size: 13px;
        line-height: 18px;
        max-height: 40px;
    }

    .parentForm .formGroup select[name="parentGender"] {
        max-width: 72px;
    }

    .parentForm .formGroupSelect {
        width: 124px;
    }

    .parentForm .formGroup .checkboxLabel {
        font-family: Overpass;
        font-size: 11px;
        line-height: 20px;
        color: #9B9B9F;
        margin-top: 10px;
    }

    .parentForm input[type=submit] {
        border: none;
        color: #ffffff;
        padding: 10px 29px;
        background: #1E5AF6;
        border-radius: 6px;
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
        cursor: pointer;
    }

    .parentForm .rowLabel {
        color: #1e5af6;
        font-weight: bold;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 5px;
        flex: 1 0 100%
    }

    .parentForm .formRow .countryCode {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        height: 40px;
        background: #F2F8FC;
        margin-right: 6px;
        border: 2px solid #F2F8FC;
        box-sizing: border-box;
        border-radius: 6px;
        padding: 0 17px;
    }

    .parentForm .formRow .countryCode img {
        height: 10px;
    }

    .parentForm .formRow .countryCode span {
        font-size: 14px;
        font-family: Overpass;
    }

    .parentForm ::-webkit-input-placeholder {
        /* Edge */
        color: #9B9B9F;
        font-family: Overpass;
        font-size: 11px;
    }

    .parentForm :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #9B9B9F;
        font-family: Overpass;
        font-size: 11px;
    }

    .parentForm ::placeholder {
        color: #9B9B9F;
        font-family: Overpass;
        font-size: 11px;
    }

    .parentForm .bottomContent {
        font-family: Overpass;
        font-style: normal;
        font-size: 11px;
        line-height: 16px;
        color: #838387;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .parentForm .bottomContent a {
        text-decoration: none;
        color: #1E5AF6;
    }

    .parentForm .bottomContent p {
        margin: 0;
    }

    .parentForm .successContainer {
        padding: 19px 34px;
        width: 509px;
    }

    .parentForm .successContainer .contactLink {
        display: none;
    }

    .parentForm .successContainer h1 {
        font-family: Poppins;
        font-weight: bold;
        font-size: 22px;
        line-height: 30px;
        color: #1E5AF6;
    }

    .parentForm .successContainer .paragraph {
        font-family: Overpass;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #5F5F63;
        max-width: 350px;
    }

    .parentForm .successContainer .bottomText {
        font-family: Overpass;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #5F5F63;
        margin-top: 14px;
        margin-bottom: 3px;
    }

    .parentForm .successContainer .qrCode {
        width: 153px;
        height: 153px;
        display: flex;
        border: 2px solid #D1DAE6;
        box-sizing: border-box;
        border-radius: 6px;
        margin-top: 5px;
    }

    .parentForm .successContainer .qrCode img {
        width: 144px;
        margin: auto;
    }

    .parentForm .successContainer .buttonDiv {
        margin-top: 11px;
    }

    .parentForm .successContainer .buttonDiv a {
        display: inline-block;
    }

    .parentForm .successContainer .buttonDiv img {
        width: 104px;
        margin-right: 6px;
    }

    .parentForm .hide {
        display: none !important;
    }

    @media only screen and (max-width: 850px) {
        .parentForm {
            background-image: none;
            align-items: normal;
        }

        .parentForm .container {
            width: 100%;
            flex-direction: column;
            height: auto;
            overflow: hidden;
            border-radius: 0px;
        }

        .parentForm .leftSection {
            width: 100%;
            padding: 0;
            background-color: inherit;
            border-radius: 0px;
        }

        .parentForm .leftSection .owl-dots {
            bottom: 0px;
            left: calc(50vw - 64px);
        }

        .parentForm .carousel-desktop {
            display: none;
        }

        .parentForm .carousel-mobile {
            display: block;
        }

        .parentForm .h2 {
            margin-bottom: 0;
        }

        .parentForm .h3 {
            display: block;
            font-style: normal;
            font-weight: bold;
            font-size: 12px;
            line-height: 30px;
            color: #1E5AF6;
            margin: 0 0 13px 0;
        }

        .parentForm .formContainer {
            width: calc(100% - 30px);
            padding: 20px 15px;
            min-height: calc(100vh - 310px);
        }

        .parentForm .formRow {
            justify-content: space-between;
        }

        .parentForm .formGroup {
            width: 100%;
        }

        .parentForm .formGroupClass {
            width: calc(50% - 10px);
        }
        .parentForm .formGroupCity {
          width: 50%;
      }
        .parentForm .formGroupEmail {
            width: 100%;
        }

        .parentForm .formGroup .label {
            color: #5F5F63;
        }

        .parentForm .successContainer {
            width: calc(100% - 30px);
            padding: 20px 15px;
            min-height: calc(100vh - 310px);
            display: flex;
            flex-direction: column;
        }

        .parentForm .successContainer .contactLink {
            display: block;
        }

        .parentForm .successContainer .qrCode {
            display: none;
        }

        .parentForm .successContainer .bottomText {
            margin-top: 0;
        }

        .parentForm .successContainer input[type=submit] {
            width: 100%;
            margin-top: 14px;
        }

        .parentForm .successContainer .bottomSectionAbsolute {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
        }

        .parentForm .successContainer .bottomSection {
            display: flex;
            align-items: center;
            flex-direction: column;
        }
    }

    header#masthead {
        display: none;
    }

    footer#colophon {
        display: none;
    }
    `}
          </style>
        </>
      </Head>

      <div className="parentForm">
        <div className="container">
          <div className="leftSection">
            <div className="owl-carousel carousel-desktop owl-theme">
              <img
                src="/assets/login-background-desktop.jpg"
                style={{ width: "100%" }}
              />
            </div>
            <div className="owl-carousel carousel-mobile owl-theme">
              <img
                src="/assets/login-background-mobile.jpg"
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="formContainer">
            <h2 className="h2">Daftar trial Kelas Live, gratis!</h2>
            <h3 className="h3">
              Langkah pertama Anda menentukan kesuksesan anak.
            </h3>
            <form className="formClass" id="parent-registration-form">
              <div className="formRow">
                <div className="formGroup formGroupLeft formGroupParenttName">
                  <label className="label">Nama orangtua</label>
                  <div className="inputGroup">
                    <select name="parentGender">
                      <option value="female">Ibu</option>
                      <option value="male">Bpk</option>
                    </select>
                    <div className="inputContainer">
                      <input
                        name="parentName"
                        type="text"
                        placeholder="Isi nama orangtua di sini"
                      />
                    </div>
                  </div>
                </div>
                <div className="formGroup  formGroupPhone">
                  <label className="label"> Nomor WhatsApp orangtua</label>
                  <div className="inputGroup">
                    <div className="countryCode">
                      <span>🇮🇩</span>
                      <span className="parentCountryCode">+62</span>
                    </div>
                    <div className="inputContainer">
                      <input
                        name="parentPhone"
                        type="text"
                        placeholder="Isi nomor WA orangtua di sini"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="formRow">
                <div className="formGroup formGroupLeft formGroupStudentName">
                  <label className="label">Nama anak</label>
                  <input
                    name="studentName"
                    type="text"
                    placeholder="Isi nama murid di sini"
                  />
                </div>
                <div className="formGroup formGroupPhone">
                  <label className="label"> Nomor WhatsApp anak</label>
                  <div className="inputGroup">
                    <div className="countryCode">
                      <span>🇮🇩</span>
                      <span className="studentCountryCode">+62</span>
                    </div>
                    <div className="inputContainer minHeight">
                      <input
                        name="studentPhone"
                        type="text"
                        placeholder="Isi nomor WA anak di sini"
                      />
                    </div>
                  </div>
                  <div className="checkboxContainer">
                    <input className="sameasParent" type="checkbox" />
                    <label>Anak saya tidak memiliki WA</label>
                  </div>
                </div>
              </div>
              <div className="formRow">
                <div className="formGroup formGroupClass">
                  <label className="label">Kelas</label>
                  <select name="studentGrade">
                    <option value="">Pilih kelas</option>
                    <option value="7">Kelas 4</option>
                    <option value="8">Kelas 5</option>
                    <option value="9">Kelas 6</option>
                    <option value="7">Kelas 7</option>
                    <option value="8">Kelas 8</option>
                    <option value="9">Kelas 9</option>
                    <option value="10">Kelas 10</option>
                    <option value="11">Kelas 11</option>
                    <option value="12">Kelas 12</option>
                  </select>
                </div>
                <div className="formGroup formGroupCity">
                  <label className="label">Kota</label>
                  <select name="studentCity">
                    <option value="">Pilih kota</option>
                    {IndonesianCities.map((city, idx) => (
                      <option key={idx} value={city.city_name}>
                        {city.city_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="formRow">
                <div className="formGroup formGroupEmail">
                  <label className="label">Email (tidak wajib)</label>
                  <input
                    name="parentEmail"
                    type="text"
                    placeholder="Isi email di sini"
                  />
                </div>
              </div>
              <input type="submit" value="Sukses dimulai di sini" />
              <div className="serverError"></div>
            </form>
            <div className="bottomContent">
              <p>
                Link download aplikasi CoLearn akan kami kirim ke nomor WhatsApp
                di atas.
              </p>
              <p>
                Melanjutkan artinya setuju dengan{" "}
                <a href="https://colearn.id/terms-and-condition/">
                  Ketentuan Layanan
                </a>{" "}
                dan{" "}
                <a href="https://colearn.id/privacy-policy/">
                  Kebijakan Privasi CoLearn.
                </a>
              </p>
            </div>
          </div>
          <div className="successContainer hide">
            <h1>
              Terima kasih telah mengambil langkah pertama menuju kesuksesan
              anak!
            </h1>
            <div className="paragraph">
              Kami telah mengirimkan link download aplikasi CoLearn ke nomor
              WhatsApp <span className="phoneNumber"></span>.
            </div>
            <div className="bottomText">
              Cari tahu bagaimana CoLearn membangun kepercayaan diri anak:
            </div>
            <a href="https://colearn.id/bimbel">
              <input type="submit" value="Kenali CoLearn lebih lanjut" />
            </a>
            <a href="https://wa.me/628174759759" className="contactLink">
              <input type="submit" value="Hubungi tim sales CoLearn" />
            </a>
            <div className="bottomSectionAbsolute">
              <div className="bottomSection">
                <div className="bottomText">
                  Download aplikasi CoLearn di sini:
                </div>
                <div className="qrCode">
                  <img src="/assets/qr-code-download.svg" />
                </div>
                <div className="buttonDiv">
                  <a href="https://play.google.com/store/apps/details?id=com.iq.colearn">
                    <img src="/assets/get_colearn_on_google_play.png" />
                  </a>
                  <a href="https://apps.apple.com/us/app/colearn/id1498950339">
                    <img src="/assets/get_colearn_on_app_store.png" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="loadingDiv hide"></div>
        </div>
      </div>

      <Script
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
    $(document).ready(() => {
        $(".owl-carousel").owlCarousel({
            loop: true,
            margin: 2,
            nav: false,
            dots: true,
            autoplay: true,
            autoplayTimeout: 5000,
            responsive: {
                0: {
                    items: 1
                }
            }
        });

        var sameasParent = false;
        var makeStudentPhoneSame = () => {
            if ($('.sameasParent').is(':checked')) $('[name="studentPhone"]').val($('[name="parentPhone"]').val());
        }
        $('.sameasParent').change(() => {
            makeStudentPhoneSame();
            if ($('.sameasParent').is(':checked')) $('[name="studentPhone"]').prop('readonly', true);
            else $('[name="studentPhone"]').prop('readonly', false);
        });
        $('[name="parentPhone"]').keyup(() => {
            makeStudentPhoneSame();
        });
        $.validator.addMethod("regx", function (value, element, regexpr) {
            return this.optional(element) || regexpr.test(value);
        }, "Please enter a valid value.");
        $.validator.addMethod("greaterThan", function (value, element, param) {
            return (this.optional(element) || value.length >= param)
        }, "Please enter a valid value.");
        $.validator.addMethod("lessThan", function (value, element, param) {
            return (this.optional(element) || value.length <= param);
        }, "Please enter a valid value.");
        $.validator.addMethod("startWith", function (value, element, param) {
            return (this.optional(element) || value.charAt(0) === param || (value.charAt(0) === '0' ? value.charAt(1) === param : false));
        }, "Please enter a valid value.");

        $(".formClass").validate({
            rules: {
                parentName: {
                    required: true,
                    regx: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z ]*)*$/,
                },
                parentPhone: {
                    required: true,
                    greaterThan: 8,
                    lessThan: 13,
                    startWith: '8'
                },
                studentName: {
                    required: true,
                    regx: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z ]*)*$/,
                },
                studentPhone: {
                    greaterThan: 8,
                    lessThan: 13,
                    startWith: '8'
                },
                parentEmail: {
                    regx:/^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                },
                studentGrade: {
                    required: true
                },
                studentCity: {
                  required: true,
                }
            },
            messages: {
                parentName: {
                    required: 'Isi nama lengkap Anda',
                    regx: 'masukan tidak valid',
                },
                parentPhone: {
                    required: 'Lengkapi nomor HP Anda',
                    greaterThan: 'Masukin minimal 8 angka, ya.',
                    lessThan: 'Hmm... nomornya kepanjangan, nih.',
                    startWith: "Hmm, kayaknya salah nih. Ketik nomor HP yang benar ya."
                },
                studentName: {
                    required: "Isi nama lengkap anak Anda",
                    regx: 'masukan tidak valid  ',
                },
                studentPhone: {
                    greaterThan: 'Masukin minimal 8 angka, ya.',
                    lessThan: 'Hmm... nomornya kepanjangan, nih.',
                    startWith: "Hmm, kayaknya salah nih. Ketik nomor HP yang benar ya."
                },
                parentEmail: {
                    regx: 'Hmm, alamat email ini sepertinya salah. Isi yang benar, ya.',
                },
                studentGrade: {
                    required: 'Pilih kelas anak Anda',
                },
                studentCity: {
                  required: 'Pilih kota anak Anda',
                }
            },
            submitHandler: function (form) {
                $('.serverError').text('');
                let formData = {
                    parentName: $('[name="parentName"]').val().trim(),
                    parentGender: $('[name="parentGender"]').val(),
                    parentPhoneNumber: $('[name="parentPhone"]').val().replace(/^0/, ''),
                    parentCountryCode: $('.parentCountryCode').text(),
                    studentName: $('[name="studentName"]').val().trim(),
                    studentPhoneNumber: ($('.sameasParent').is(':checked') ? null : $('[name="studentPhone"]').val().replace(/^0/, '')) || null,
                    studentCountryCode: $('.studentCountryCode').text(),
                    parentEmail: $('[name="parentEmail"]').val() || null,
                    studentGrade: $('[name="studentGrade"]').val(),
                    studentCity: $('[name="studentCity"]').val().trim(),
                };
                $('.loadingDiv').removeClass('hide');
                $.ajax({
                    type: "POST",
                    dataType: 'json',
                    contentType: 'application/json',
                    url: '${process.env.NEXT_PUBLIC_BASE_API}/user-management/v1/leads/parent',
                    data: JSON.stringify(formData),
                    success: function (data) {
                        $('.phoneNumber').text(
                            formData.studentPhoneNumber ?
                                formData.studentCountryCode + formData.studentPhoneNumber :
                                formData.parentCountryCode + formData.parentPhoneNumber);
                        $('.loadingDiv').addClass('hide');
                        $('.formContainer').addClass('hide');
                        $('.successContainer').removeClass('hide');
                    },
                    error: function (data) {
                        $('.loadingDiv').addClass('hide');
                        let resp = jQuery.parseJSON(data.responseText);
                        $('.serverError').text(resp.message || 'something wentwrong');
                    }
                });
            }
        });
    });
    `
        }}></Script>
    </>
  );
};

export default RegisterTrial;
